import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';

import { Paragraph } from '@app/shared/ui/atoms/Common';

interface WhatIsDomVideoProps {
  onBtnClick: () => void;
}

export function WhatIsDomVideo({ onBtnClick }: WhatIsDomVideoProps) {
  const { t } = useTranslation();

  return (
    <div className="relative">
      <div
        className="absolute bottom-2 left-2 flex h-6 cursor-pointer items-center space-x-2 rounded-xl bg-[#e9f5fa] px-2"
        onClick={onBtnClick}
      >
        <X className="w-4 text-secondary-foreground" />
        <Paragraph size="sm" variant="secondary">
          {t('home.slider.what_is_dom.close_video')}
        </Paragraph>
      </div>
      <iframe
        width="100%"
        height="210px"
        src="https://www.youtube.com/embed/4hsBkevc1HQ?si=1-z6mSs7K8-QVohE"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      />
    </div>
  );
}
